module.exports = "/assets/data/82abf0c1a224cc4e6884e83b08dd77f7-NG8.data.json";